import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import WP from 'WP';
import Container from 'partials/Container';
import SingleHeader from 'partials/SingleHeader';
import Image from 'partials/Image';
import ContentWithSidebar from 'partials/ContentWithSidebar';
import { redirect404, removeLinebreaks, stripTags } from 'helpers';
import { FacebookShareLink, TwitterShareLink } from 'partials/ShareLinks';
import HeadMeta from 'partials/HeadMeta';
import Loader from 'partials/Loader';

import { setCurrentView } from 'store';

class SingleNews extends Component {

    constructor() {
        super();

        this.state = {
            post: null
        }
    }

    componentWillMount() {
        this.mounted = true;

        api.getPostBySlug(this.props.match.params.slug)
            .then(resp => {
                if(resp.data[0]) {
                    //console.log('POST: ', resp.data[0]);
                    if(this.mounted) this.setState({ post: resp.data[0] })
                    this.props.setCurrentView(resp.data[0]);
                } else {
                    redirect404();
                }
            })
            .catch(e => console.log(e));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _formatMeta() {
        const { post } = this.state;
        const title = post ?
            post.yoast && post.yoast.title ?  post.yoast.title : removeLinebreaks(stripTags(post.acf.title || post.title.rendered))+' - HLM'
            : '';
        return {
            title: title,
            description: '',
            ogUrl: '',
            ogType: '',
            ogTitle: '',
            ogDescription: '',
            ogImage: ''
        }
    }

    render() {
        const { post } = this.state;

        const featuredImage = post ? post.featured_image_src : null;
        
        return (
            <Wrapper>

                <Loader loaded={post} />

                {post &&
                    <Container>

                        <HeadMeta {...this._formatMeta.bind(this)() }/>

                        <SingleHeader title={post.acf.title || post.title.rendered} excerpt={post.acf.excerpt} />
                        
                        <Image image={featuredImage} className="expandable" background ratio="1259:783" />
                        <Share>
                            <label>{WP.trans.share || 'Del'}</label>
                            <FacebookShareLink url={post.link} title={post.acf.title || post.title.rendered} />
                            <TwitterShareLink url={post.link} title={post.acf.title || post.title.rendered} />
                        </Share>

                        <ContentWithSidebar data={post} />

                    </Container>
                }
            </Wrapper>
        );
    }
}

const actions = {
    setCurrentView
}

export default connect(null, actions)(withRouter(SingleNews));

const Wrapper = styled.article`
    display:block;
    position:relative;
    width:100%;
`

const Share = styled.div`
    font-size:14px;
    text-align: right;
    padding-top:20px;
    label {
        color: #797979;
        display:block;
        margin-bottom: 5px;
    }
    a {
        margin-left: 5px;
    }
`



// WEBPACK FOOTER //
// ./src/views/SingleNews.js